import { ref } from 'vue';

export function useEditCardBonuses() {
    const welcomeBonus = ref({
        type: '',
        minimum_spend_deadline: null,
        minimum_spend_amount: null,
        bonus_amount: null,
        bonus_units: '',
        date_received: null,
        received: false,
    });

    const tieredBonuses = ref([
        {
            type: '',
            tier_number: 1,
            bonus_amount: null,
            bonus_units: '',
            minimum_spend_amount: null,
            minimum_spend_deadline: null,
            date_received: null,
            received: false,
        },
    ]);

    const bonusOffers = ref([
        {
            type: '',
            bonus_amount: null,
            bonus_units: '',
            minimum_spend_amount: null,
            minimum_spend_deadline: null,
            date_received: null,
            received: false,
            product_changed: false,
        },
    ]);

    const originalBonusOffers = ref([
        {
            type: '',
            bonus_amount: null,
            bonus_units: '',
            minimum_spend_amount: null,
            minimum_spend_deadline: null,
            date_received: null,
            received: false,
            product_changed: true,
        },
    ]);

    const resetWelcomeBonus = () => {
        welcomeBonus.value = {
            type: '',
            bonus_amount: null,
            minimum_spend_amount: null,
            minimum_spend_deadline: null,
            date_received: null,
            received: false,
            bonus_units: '',
        };
    };

    const resetTieredBonuses = () => {
        tieredBonuses.value = [
            {
                type: '',
                tier_number: 1,
                bonus_amount: null,
                bonus_units: '',
                minimum_spend_amount: null,
                minimum_spend_deadline: null,
                date_received: null,
                received: false,
            },
        ];
    };

    const resetBonusOffers = () => {
        bonusOffers.value = [
            {
                type: '',
                bonus_amount: null,
                bonus_units: '',
                minimum_spend_amount: null,
                minimum_spend_deadline: null,
                date_received: null,
                received: false,
                product_changed: false,
            },
        ];
    };

    const resetOriginalBonusOffers = () => {
        originalBonusOffers.value = [
            {
                type: '',
                bonus_amount: null,
                bonus_units: '',
                minimum_spend_amount: null,
                minimum_spend_deadline: null,
                date_received: null,
                received: false,
                product_changed: true,
            },
        ];
    };

    const handleResetBonuses = () => {
        resetWelcomeBonus();
        resetTieredBonuses();
    };

    const initializeBonuses = (localCardValue) => {
        if (localCardValue.welcome_bonus) {
            welcomeBonus.value = localCardValue.welcome_bonus;
            if (
                welcomeBonus.value.type === 'tiered' &&
                welcomeBonus.value.tiers?.length > 0
            ) {
                tieredBonuses.value = welcomeBonus.value.tiers;
            } else {
                resetTieredBonuses();
            }
        } else {
            resetWelcomeBonus();
            resetTieredBonuses();
        }

        if (localCardValue.bonus_offers?.length > 0) {
            let filteredOffers = localCardValue.bonus_offers.filter(
                (offer) => !offer.product_changed
            );
            if (filteredOffers.length > 0) {
                bonusOffers.value = filteredOffers;
            } else {
                resetBonusOffers();
            }
        } else {
            resetBonusOffers();
        }

        if (localCardValue.product_changed) {
            const productChangedBonusOffers =
                localCardValue.bonus_offers?.filter(
                    (offer) => offer.product_changed
                ) || [];
            if (productChangedBonusOffers.length > 0) {
                originalBonusOffers.value = productChangedBonusOffers;
            }
        }
    };

    return {
        welcomeBonus,
        tieredBonuses,
        bonusOffers,
        originalBonusOffers,
        resetWelcomeBonus,
        resetTieredBonuses,
        resetBonusOffers,
        resetOriginalBonusOffers,
        handleResetBonuses,
        initializeBonuses,
    };
}
